module.exports = __webpack_public_path__ + "media/images/country_flags/bn-d987bd86f14bf34b3f405fc35ff94714.png";